module.exports = __webpack_public_path__ + "static/img/btn-get.bb05a8bb.png";